// extracted by mini-css-extract-plugin
export default {"title":"MergeExportError-title___iCBxA","close":"MergeExportError-close___ZnGGs","text":"MergeExportError-text___ZKUzL","buttons":"MergeExportError-buttons___-8kbm"};